const bindRevealEvents = () => {
  $(window).on('closeme.zf.reveal', () => {
    $('.container').removeClass('blurry');
  });

  $(window).on('closed.zf.reveal', () => {
    $('.container').removeClass('blurry');
  });

  $(window).on('open.zf.reveal', () => {
    $('.container').addClass('blurry');
  });
}

export default bindRevealEvents;